export const AppStatus = {
    0: "Pending",
    1: "Live",
    2: "Remove",
  };